<template>
  <div class="one-column-view bg-green">
    <div class="article-content nft-content">
      <img
        src="../../assets/GSG-token-banner.jpg"
        alt="GSG Token Banner"
        class="w-100"
      />
      <div
        class="d-flex flex-column-reverse flex-md-row justify-content-around align-items-center mb-3"
      >
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>抢购多达1,000 个GSG NFT 代币</h1>
          <p>
            GSG是让您的流量挖掘事业飞黄腾达的入口。加入之后您可以提高收入，潜在收入从20%到高达60%甚至更多。这是指数级增长的终极机会。立即注册。仅发行20,000
            GSG。
          </p>
          <div class="nft-btns">
            <div class="btn GSG-btn">GSG</div>
            <router-link to="nft-gema" class="btn GEMA-btn">GEMA</router-link>
          </div>
        </div>
        <div class="w-100 w-md-35 p-0">
          <img
            src="../../assets/GoldMiner-00475.png"
            alt="GSG"
            class="m-0 mx-auto"
          />
        </div>
      </div>
      <div class="nft-token-section">
        <div
          class="d-flex flex-column flex-md-row justify-content-around align-items-center"
        >
          <div class="w-100 w-md-50">
            <img
              src="../../assets/GoldMiner-00028.png"
              alt="Gold Miner 00028"
              class="m-0 mx-auto w-100"
            />
          </div>
          <div class="w-100 w-md-50 px-1 px-md-4">
            <h1>NFT GSG Token #00028</h1>
            <h5>NFT描述</h5>
            <div class="d-flex flex-column flex-md-row justify-content-between">
              <span class="color-gold my-1">总供应 <strong>1,000</strong></span>
              <span class="color-gold my-1">现有 <strong>500</strong></span>
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white"><strong>OG</strong></p>
                <p class="m-0 w-100 text-end text-white pe-5">50</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(25个推荐)</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">结束于</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0</span>
                  </p>
                  <p class="m-0 text-white">每个钱包1个</p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white"><strong>Whitelist</strong></p>
                <p class="m-0 w-100 text-end text-white pe-5">100</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(10个推荐)</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">结束于</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0.01</span>
                  </p>
                  <p class="m-0 text-white">每个钱包1个</p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="w-50 d-flex flex-column justify-content-between">
                <p class="m-0 w-100 text-white"><strong>Early-stage</strong></p>
                <p class="m-0 w-100 text-end text-white pe-5">350</p>
              </div>
              <div class="w-50 text-end px-2">
                <p class="mb-2 text-white">(5个推荐)</p>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0">结束于</p>
                  <p class="m-0">9:00 AM 07/18</p>
                </div>
                <div class="d-flex mb-2 justify-content-between">
                  <p class="m-0 text-white">
                    <img
                      src="../../assets/Ethereum-icon-purple.png"
                      alt="Ethereum Icon"
                      class="m-0 d-inline w-auto"
                    /><span>0.2</span>
                  </p>
                  <p class="m-0 text-white">每个钱包5个</p>
                </div>
              </div>
            </div>
            <router-link to="nft-all-gsg-showdetail-GSG00028" class="mint-btn mt-5 mb-2">铸造</router-link>
            <div class="d-flex justify-content-between w-100 text-white">
              <p class="text-white">已铸造 (0%)</p>
              <p class="text-white">0</p>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center gap-5 my-3"
        >
          <div class="wallet-brand">
            <img src="../../assets/MetaMask.png" alt="MetaMask" />
          </div>
          <div class="wallet-brand">
            <img src="../../assets/TrustWallet.png" alt="Trust Wallet" />
          </div>
          <div class="wallet-brand">
            <img src="../../assets/WalletConnect.png" alt="WalletConnect" />
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center gap-5 my-3"
        >
          <div class="wallet-brand">
            <img src="../../assets/Exodus.png" alt="Exodus" />
          </div>
          <div class="wallet-brand">
            <img src="../../assets/SafePal.png" alt="SafePal" />
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5"
      >
        <div class="w-100 w-md-50 p-0 pe-md-5">
          <p class="p-0 pe-md-5">
            GOLD将分阶段发放总计20,000个GSG（高准入）矿权。与
            GSR（普通入会）不同，该资格允许GSG通过网络发展推荐企业加入GOLD
            应用程序，从而成为与该企业ID相关联的全球独家营销代理（GEMA）。
          </p>
        </div>
        <div class="tokens-table w-100 w-md-50">
          <div class="tokens-table-head">早期阶段的GSG代币*</div>
          <div class="tokens-row bg-white">
            <div>前1000名矿工</div>
            <div>
              <img
                src="../../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.06</span>
            </div>
          </div>
          <div class="tokens-row bg-gray">
            <div>后续2000名矿工</div>
            <div>
              <img
                src="../../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.09</span>
            </div>
          </div>
          <div class="tokens-row bg-white">
            <div>后续6000名矿工</div>
            <div>
              <img
                src="../../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.12</span>
            </div>
          </div>
          <div class="tokens-row bg-gray">
            <div>后续9800名矿工</div>
            <div>
              <img
                src="../../assets/Ethereum-icon-purple.png"
                alt="Ethereum Icon"
                class="m-0 d-inline w-auto"
              /><span>0.15</span>
            </div>
          </div>
          <div class="d-flex gap-1 mt-2">
            <span>*</span
            ><span>折扣价仅限20,000名矿工。汇率以以太坊为单位。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.nft-content {
  p {
    color: #07050a;
    font-size: 1.3rem;
    line-height: 2rem;
  }
}
.nft-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  .btn {
    height: 16vw;
    max-height: 62px;
    width: 100%;
    border-radius: 16vw;
    font-size: 6vw;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .GSG-btn {
    background: linear-gradient(to right, #ef8200, #ffe65a);
  }
  .GEMA-btn {
    background: linear-gradient(to right, #06a5ff, #3dde91);
  }
}
.nft-token-section {
  background-color: #07050a;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1.3rem;
  h1 {
    color: #f8fffe;
    font-size: 2rem;
    margin: 1rem 0;
  }
  h5 {
    color: #f8fffe;
    font-size: 1rem;
    margin: 1rem 0;
  }
  p {
    color: #6c6f83;
    font-size: 0.95rem;
    line-height: 1.4rem;
  }
  .mint-btn {
    width: 100%;
    height: 16vw;
    max-height: 62px;
    border-radius: 16vw;
    font-size: 6vw;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(to right, #06a5ff, #3dde91);
  }
  .wallet-brand {
    height: 50px;
    width: auto;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.tokens-table {
  border-radius: 1rem;
  .tokens-table-head {
    background: linear-gradient(to right, #ef8200, #ffe65a);
    font-size: 1.5rem;
    color: white;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .tokens-row {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    font-size: 1.3rem;
    span {
      vertical-align: middle;
    }
  }
  .bg-gray {
    background-color: #f1f3fb;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nft-btns {
    flex-wrap: nowrap;
    .btn {
      width: 50%;
      font-size: 24px;
    }
  }
  .nft-token-section {
    .mint-btn {
      font-size: 24px;
    }
  }
}
</style>
